import React, { useState } from "react";
import signinLogo from "../../assets/images/Tradevibe/signinLogo.png";
import logo from "../../assets/images/login/Nathicharami Logo.png";
import { BsFillTelephoneFill } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import { object, string } from "yup";
import { axiosInstance } from "../../axiosInstance";
import Preloader from "../../Components/Loader/Loader";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./Login.css";

const LoginSchema = object({
  username: string()
    .required("Mobile number is required")
    .test(
      "is-valid-username-or-mobile",
      "Enter valid mobile number or username",
      function (value) {
        const trimmed = value?.trim() || "";
        const isMobile = /^[6-9]\d{9}$/.test(trimmed);
        const isUsername = /^[a-zA-Z0-9@._-]{3,50}$/.test(trimmed);
        return isMobile || isUsername;
      },
    ),
  // password: string().required("Password is required"),
});

export function Login() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [serverError, setServerError] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);

  const formik = useFormik({
    initialValues: {
      username: "",
      // password: "",
    },
    validationSchema: LoginSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        setIsLoading(true);
        setServerError("");

        const payload = {
          username: values.username,
          // password: values.password,
        };

        const response = await axiosInstance.post("/agent/login/", payload);
        const data = response.data;

        // Success case
        if (data.status === "success") {
          toast.success(data.message || "Login Successfully!");
          resetForm();

          // Store username
          localStorage.setItem("username", values.username);
          // store mobile number
          localStorage.setItem("mobile_number",data.data.mobile_no);
          
          // if (data.data?.token) {
          //   // sessionStorage.setItem("token", data.data.token);
          //   localStorage.setItem("token", data.data.token);
          // }

          setTimeout(() => {
            navigate("/signin-otp");
            setIsLoading(false);
          }, 2000);
        } else {
          // Handle error responses that don’t throw
          handleErrorResponse(data);
        }
      } catch (error) {
        // Handle backend errors (403, 401, etc.)
        console.error("Login error:", error);

        const data = error.response?.data;

        if (data?.is_verified === false || data?.response_code === 403) {
          toast.info(
            "Your account is not verified. Please verify using the OTP sent to your registered number.",
          );

          if (data.mobile_no) {
            localStorage.setItem("mobile_number", data.mobile_no);
          }
          localStorage.setItem("pending_verification_user", values.username);

          setTimeout(() => {
            navigate("/otp");
            setIsLoading(false);
          }, 1500);
        } else {
          // Generic error fallback
          setServerError("Invalid mobile number or password.");
          toast.error(data?.message || "Submission failed! Please try again.");
          setIsLoading(false);
        }
      }
    },
  });

  // Helper for backend "error" responses that don’t trigger catch
  const handleErrorResponse = (data) => {
    if (data.is_verified === false || data.response_code === 403) {
      toast.info(
        "Your account is not verified. Please verify using the OTP sent to your registered number.",
      );

      if (data.mobile_no) {
        localStorage.setItem("mobile_number", data.mobile_no);
      }

      setTimeout(() => {
        navigate("/otp");
        setIsLoading(false);
      }, 1500);
    } else {
      toast.error(data.message || "Something went wrong, please try again!");
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && <Preloader />}
      <ToastContainer />
      <div className="signin-container">
        <div className="signin-left">
          <div>
            <div className="signin-logo">
              <img src={signinLogo} alt="signin logo" />
            </div>
            {/* <div className="signin-lefttext">
              Welcome to Tradevibe Referral — your platform to manage medicine
              deliveries with speed, security, and reliability. Together, we
              ensure healthcare providers get the medicines they need, on time
              you can earn upto 1000 to 2000 daily.
            </div> */}
          </div>
        </div>
        <div className="signin-rights">
          <div>
            <form
              className="signin-formContainer-sign-in"
              onSubmit={formik.handleSubmit}
            >
              <div className="signin-title">Sign In</div>
              <div className="signin-subtitle">
                Welcome to Tradevibe Referral
              </div>

              {/* Username / Mobile */}
              <div className="signin-field">
                <label>
                  <span className="text-danger">*</span>Mobile Number
                </label>
                <div>
                  <input
                    type="tel"
                    placeholder="Enter mobile number"
                    maxLength={10}
                    pattern="[0-9]*"
                    inputMode="numeric"
                    name="username"
                    value={formik.values.username}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={
                      formik.touched.username && formik.errors.username
                        ? "input-error-signIn"
                        : ""
                    }
                  />
                  {formik.touched.username && formik.errors.username && (
                    <div className="error-message-signIn">
                      {formik.errors.username}
                    </div>
                  )}
                </div>
              </div>

              {/* Password */}

              {/* <div className="signin-field password-field mt-3">
                <label>
                  <span className="text-danger">*</span>Password
                </label>
                <div className="password-input-wrapper">
                  <input
                    type={passwordVisible ? "text" : "password"}
                    placeholder="Enter Password"
                    name="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={
                      formik.touched.password && formik.errors.password
                        ? "input-error-signIn"
                        : ""
                    }
                  />
                  <span
                    className="password-toggle-icon"
                    onClick={() => setPasswordVisible((prev) => !prev)}
                  >
                    {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
                {formik.touched.password && formik.errors.password && (
                  <div className="error-message-signIn">
                    {formik.errors.password}
                  </div>
                )}
                {serverError && (
                  <div
                    className="error-message-signIn"
                    style={{ marginBottom: "10px" }}
                  >
                    {serverError}
                  </div>
                )}
              </div> */}

              {/* Submit */}
              <div className="btnLogin">
                <button type="submit" disabled={isLoading}>
                  {isLoading ? "Logging in..." : "Login"}
                </button>
              </div>

              {/* Signup link */}
              <div className="forgot-text">
                Don’t have an account?{" "}
                <Link to="/signup" className="register-link">
                  Sign Up
                </Link>
              </div>

              <div className="forgot-text">
                <Link to="/forgot-password" className="register-link">
                  Forgot Password?
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
